import { Button, colors } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const ButtonStyled = styled(Button)<{ $isClosed: boolean }>`
  font-weight: 700;
  height: 3.8rem;
  padding: 0 1rem;
  font-size: 1.6rem;
  line-height: 2.6rem;
  border: 0.2rem solid ${({ $isClosed }): string => ($isClosed ? 'transparent' : colors.blue[600])};
`;
